(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class BaseHeader extends HTMLElement {
    constructor() {
      super();
      this.mobileDrawerBtn = this.querySelector('[mobile-drawer-btn]');
      this.mobileDrawerContent = this.querySelector('[mobile-drawer-content]');
      this.section = this.closest('.shopify-section');
      this.initMobileDrawer();
      if (Shopify.designMode) {
        document.body.classList.remove('overflow-hidden');
      }
      if (Shopify.designMode && this.section) {
        this.searchDrawer = document.querySelector('search-drawer-wrapper');
        this.cartDrawer = document.querySelector('cart-drawer');

        this.section.addEventListener('shopify:section:load', () => {
          document.body.classList.remove('overflow-hidden');
          this.searchDrawer?.connectedCallback?.();
          this.cartDrawer?.connectedCallback?.();
        });
      }
      theme?.onMobileSizeChange?.((isMobile) => {
        if (!isMobile && this.mobileDrawerContent?.classList.contains('drawer-open')) {
          this.closeMobileDrawer();
        }
      });

      this.initHeaderCategories();
    }



    initMobileDrawer() {
      if (!this.mobileDrawerBtn || !this.mobileDrawerContent) return;
      this.mobileDrawerBtn.addEventListener('click', () => this.openMobileDrawer());
      this.mobileDrawerBtn.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          this.openMobileDrawer();
        }
      });

      const closeBtn = this.mobileDrawerContent.querySelector('[drawer-close-btn]');
      const backdrop_close_Btn = this.mobileDrawerContent.querySelector('[drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.closeMobileDrawer());
      if (backdrop_close_Btn) backdrop_close_Btn.addEventListener('click', () => this.closeMobileDrawer());

      this.mobileDrawerContent.addEventListener('click', (e) => {
        const backBtn = e.target.closest('[data-back-to-menu]');
        if (backBtn) {
          e.preventDefault();
          backBtn.closest('[data-menu-item]')?.classList.remove('active');
          return;
        }

        if (e.target.tagName === 'A' || e.target.closest('a')) return;

        const menuItem = e.target.closest('[data-menu-item]');
        if (menuItem?.querySelector('.mobile-menu-submenu')) {
          e.preventDefault();
          menuItem.parentElement.querySelectorAll('[data-menu-item]').forEach((sib) => {
            if (sib !== menuItem) sib.classList.remove('active');
          });
          menuItem.classList.add('active');
        }
      });

      this.mobileDrawerContent.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          this.closeMobileDrawer();
          this.mobileDrawerBtn.focus();
          return;
        }
        if (event.key === 'Enter') {
          const backBtn = event.target.closest('[data-back-to-menu]');
          if (backBtn) {
            event.preventDefault();
            backBtn.closest('[data-menu-item]')?.classList.remove('active');
            setTimeout(() => {
              const isHorizontalCard = backBtn.classList.contains('horizontal-product-card-back');
              const activeWrapper = this.mobileDrawerContent.querySelector('.mobile-menu-item.active');

              const focusTarget = isHorizontalCard && activeWrapper ? activeWrapper : this.mobileDrawerContent;
              trapFocus(focusTarget);
            }, 500);
            return;
          }

          if (event.target.tagName === 'A' || event.target.closest('a')) return;

          const menuItem = event.target.closest('[data-menu-item]');
          if (menuItem?.querySelector('.mobile-menu-submenu')) {
            event.preventDefault();
            menuItem.parentElement.querySelectorAll('[data-menu-item]').forEach((sib) => {
              if (sib !== menuItem) sib.classList.remove('active');
            });
            menuItem.classList.add('active');
            setTimeout(() => {
              trapFocus(menuItem);
            }, 500);
          }
        }
      });
    }

    openMobileDrawer() {
      this.mobileDrawerContent.classList.add('drawer-open');
      this.mobileDrawerContent.setAttribute('drawer-open', '');
      document.body.classList.add('overflow-hidden');
      // setTimeout(() => {
      //   trapFocus(this.mobileDrawerContent,this.mobileDrawerContent.querySelector('[drawer-close-btn]'));
      // }, 500);
    }

    closeMobileDrawer() {
      this.mobileDrawerContent.classList.remove('drawer-open');
      this.mobileDrawerContent.removeAttribute('drawer-open');
      document.body.classList.remove('overflow-hidden');
      this.querySelectorAll('[data-menu-item].active').forEach((menu) => menu.classList.remove('active'));
    }

    attachOverlay(){
      document.body.classList.add('has-header-overlay','has-dropdown-menu');
    }

    removeOverlay(){
      const isSearchOpen = document.querySelector('.section-header').classList.contains('search-open') || false;
      if(isSearchOpen){
        document.body.classList.remove('has-dropdown-menu');
        return;
      }
        document.body.classList.remove('has-header-overlay','has-dropdown-menu');  
      
    }

    initHeaderCategories() {
      const categoriesMenu = this.querySelector('[data-categories-wrapper]');
      const categoriesButton = this.querySelector('[data-categories-button]');
      const categoriesDropdown = this.querySelector('[data-categories-dropdown]');
      const openType = categoriesButton?.dataset?.open;
      if (categoriesMenu && categoriesButton && categoriesDropdown) {
        const handleOutsideClick = (e) => {
          // click is inside menu or button → ignore
          if (
            categoriesMenu.contains(e.target) ||
            categoriesButton.contains(e.target)
          ) {
            return;
          }

          // outside click → close
          categoriesMenu.classList.remove('open');
          document.removeEventListener('click', handleOutsideClick);
          this.removeOverlay();
        }; 
         if (openType == "click") {
           categoriesButton.addEventListener('click', (e) => {
             e.stopPropagation(); // prevent immediate document close
             const isOpen = categoriesMenu.classList.toggle('open');
              const isSeachCategoriesOpen = document.querySelector('[select-categories]').classList.contains('open') || false
              if (isSeachCategoriesOpen) {
               document.querySelector('[select-categories]').classList.remove('open')
              } 
             document.querySelectorAll('mega-menu').forEach(menu => { 
              if (menu !== this) {
                 menu.closeAllMenus();
               }
             });
   
             // attach outside click only when opened
             if (isOpen) {
               // delay ensures button click finishes first
               setTimeout(() => {
                 document.addEventListener('click', handleOutsideClick);
               }, 0);
               this.attachOverlay();
             } else {
               document.removeEventListener('click', handleOutsideClick);
               this.removeOverlay();
             }
           });
         }else{
           categoriesMenu.addEventListener('mouseenter', (e) => {
              e.stopPropagation(); 
              categoriesMenu.classList.add('open');
              const isSeachCategoriesOpen = document.querySelector('[select-categories]').classList.contains('open') || false
              if (isSeachCategoriesOpen) {
               document.querySelector('[select-categories]').classList.remove('open')
              } 
               document.querySelectorAll('mega-menu').forEach(menu => { 
              if (menu !== this) {
                 menu.closeAllMenus();
               }
               this.attachOverlay();

             });
           })
           categoriesMenu.addEventListener('mouseleave', (e) => {
            e.stopPropagation(); 
              categoriesMenu.classList.remove('open');
              this.removeOverlay();
           })
         }

        categoriesButton.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            categoriesButton.click();
          }
        });
      }

      const menu = this.querySelector('[data-categories-list]');
      if (!menu) return;
      let activeItem = null;

      const getMenuItem = (target) =>
        target.closest('[data-trigger="hover"]');

      menu.addEventListener('mousemove', (e) => {
        const item = getMenuItem(e.target);
        // mouse is inside UL but not on any menu item
        if (!item) {
          return;  
        } 
        // already active → do nothing
        if (activeItem === item) return;
        // deactivate previous
        if (activeItem) {
          activeItem.classList.remove('active');
        }
        // activate new
        activeItem = item;
        activeItem.classList.add('active');
      });
      // when mouse leaves entire menu → close everything
      menu.addEventListener('mouseleave', () => {
        if (activeItem) {
          activeItem.classList.remove('active');
          activeItem = null;
        }
      });

      const canHover = window.matchMedia('(hover: hover)').matches;
      if (!canHover) {
        const items = menu.querySelectorAll('[data-trigger="hover"]');

        items.forEach((item) => {
          const link = item.querySelector('a');
          if (!link) return;

          link.addEventListener('click', (e) => {
            // if item is not active → first tap opens submenu
            if (!item.classList.contains('active')) {
              e.preventDefault();

              // close previous
              if (activeItem && activeItem !== item) {
                activeItem.classList.remove('active');
              }

              item.classList.add('active');
              activeItem = item;
              return;
            }

            // if already active → allow navigation (second tap)
          });
        });

        // tap outside menu closes everything
        document.addEventListener('click', (e) => {
          if (!menu.contains(e.target)) {
            if (activeItem) {
              activeItem.classList.remove('active');
              activeItem = null;
            }
          }
        });
      }

    }

  }

  class StickyHeader extends BaseHeader {
    constructor() {
      super();

      this.section = this.closest('.shopify-section');
      this.header = document.querySelector('.section-header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerType = this.getAttribute('data-sticky-type') || '';
      this.headerIsAlwaysSticky = ['always', 'on-scroll-up'].includes(this.headerType);
      this.headerAlways = this.headerType === 'always';
      this.headerBounds = {};
      this.headerHeight = 0;
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isScrolling = null;
      this.marginHeight;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };
    }

    connectedCallback() {
      if (this.headerType != 'none') {
        this.setHeaderHeight();
        this.observeMediaQuery();
        this.setupScrollEvents();
        this.createObserver();
      }
    }

    disconnectedCallback() {
      this.cleanupScrollEvents();
    }

    /** ─── Scroll & Sticky Header ───────────────────── */
    observeMediaQuery() {
      const mediaQuery = window.matchMedia('(max-width: 990px)');
      mediaQuery.addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setupScrollEvents() {
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      if (this.headerIsAlwaysSticky) this.header?.classList.add('header-sticky');
    }

    cleanupScrollEvents() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      const headerWrapper = this.closest('.header-main-wrapper');
      if (!headerWrapper) return;

      this.headerHeight = headerWrapper.getBoundingClientRect().height;
      document.body.style.setProperty('--headerHeight', `${this.headerHeight}px`);
      document.body.style.setProperty('--headerDynamicHeight', `${this.headerHeight}px`);
      const headerBottomBar = headerWrapper.querySelector('[data-header-bottom-bar]');
      if(headerBottomBar){
       const headerBottomBarHeight = headerBottomBar.getBoundingClientRect().height;
        document.body.style.setProperty('--headerBottomBarHeight', `${headerBottomBarHeight}px`);        
      }
    }

    createObserver() {
      if (!this.header) return;
      const observer = new IntersectionObserver(([entry]) => {
        this.headerBounds = entry.intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    updateDynamicHeight() {
      const headerEl = this.header?.querySelector('header');
      if (!headerEl) return;
      const height = headerEl.getBoundingClientRect().height;
      document.body.style.setProperty('--headerDynamicHeight', `${height}px`);
    }
    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (this.predictiveSearch?.isOpen) return;
      if (!this.headerIsAlwaysSticky) return;

      const isScrollingDown = scrollTop > this.currentScrollTop;
      const pastHeader = scrollTop > this.headerBounds.bottom;
      const pastThreshold = scrollTop > 50;
      const isMobile = window.innerWidth <= 768;
      const hideThreshold = isMobile ? 300 : 600;
      if (this.headerType === 'on-scroll-up' || this.headerType === 'always') {
        if (pastThreshold && isScrollingDown && pastHeader) {
          if (scrollTop > 50) {
            this.updateDynamicHeight();
            this.header.classList.add('scrolled-header');
            this.toggleSpacing(false);
          }
          if (scrollTop > hideThreshold) {
            if (!this.preventHide) this.hide();
          }
        } else if (!isScrollingDown && pastHeader) {
          this.updateDynamicHeight();
          this.header.classList.add('scrolled-header');
          this.preventReveal ? this.deferHide() : this.reveal();
          this.toggleSpacing(false);
        } else if (scrollTop <= this.headerBounds.top) {
          this.reset();
        }
      }

      this.currentScrollTop = scrollTop;
    }

    toggleSpacing(add = true) {
      const isTransparent = this.header?.querySelector('header').classList.contains('header-transparent');
      if (isTransparent) {
        this.header?.querySelector('header').classList.toggle('section-spacing', add);
        if (!this.marginHeight) {
          this.marginHeight = getComputedStyle(document.body).getPropertyValue('--headerMargin').trim();
        }
        if (this.marginHeight && add == false) {
          document.body.style.setProperty('--headerMargin', `0px`);
        }
      } else {
        const wrapper = this.header?.querySelector('[header-main-wrapper]');
        if (!wrapper) return;
        wrapper.classList.toggle('section-spacing', add);
      }
    }

    deferHide() {
      clearTimeout(this.isScrolling);
      this.isScrolling = setTimeout(() => (this.preventReveal = false), 66);
      this.hide();
    }

    /** ─── Header State Methods ─────────────────────── */
    hide() {
      if (this.headerAlways) return;
      document.body.style.setProperty('--headerDynamicHeight', `0px`);
      document.body.classList.add('header-pinned');
      this.header.classList.add('header-hidden', 'header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerAlways) return;
      // document.body.style.setProperty('--headerDynamicHeight', `${this.headerHeight}px`);
      document.body.classList.remove('header-pinned');
      this.header.classList.remove('header-hidden');
      this.header.classList.add('header-sticky', 'animate');
    }

    reset() {
      this.header.classList.remove('scrolled-header');
      document.body.style.setProperty('--headerDynamicHeight', `${this.headerHeight}px`);
      if (this.marginHeight) {
        document.body.style.setProperty('--headerMargin', this.marginHeight);
      }
      this.toggleSpacing(true);
      if (!this.headerAlways) document.body.classList.remove('header-pinned');
    }

    /** ─── Helpers ─────────────────────────────────── */
    closeMenuDisclosure() {
      this.disclosures ??= this.header?.querySelectorAll('header-menu');
      this.disclosures?.forEach((d) => d.close?.());
    }

    closeSearchModal() {
      this.searchModal ??= this.header?.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }
  customElements.define('sticky-header', StickyHeader, { extends: 'header' });

  class BasicHeader extends BaseHeader {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.setHeaderHeight();
    }
    setHeaderHeight() {
      const headerWrapper = this.closest('.header-main-wrapper');
      if (!headerWrapper) return;
      this.headerHeight = headerWrapper.getBoundingClientRect().height;
      document.body.style.setProperty('--headerHeight', `${this.headerHeight}px`);
      document.body.style.setProperty('--headerDynamicHeight', `0px`);

      const headerBottomBar = this.querySelector('[data-header-bottom-bar]');
      if(headerBottomBar){
       const headerBottomBarHeight = headerBottomBar.getBoundingClientRect().height;
        document.body.style.setProperty('--headerBottomBarHeight', `${headerBottomBarHeight}px`);        
      }
    }
  }
  customElements.define('basic-header', BasicHeader, { extends: 'header' });

  class HeaderButton extends HTMLElement {
    constructor() {
      super();
      this.hamburgerWrapper = document.body.querySelector('hamburger-wrapper');
      this.hamburgerCloseBtn = document.body.querySelector('[hamburger-close]');
      this.initEvents();
    }

    initEvents() {
      // Open menu on click of this button
      this.addEventListener('click', () => this.openHamburger());

      // Close menu on close button click
      this.hamburgerCloseBtn?.addEventListener('click', () => this.closeHamburger());

      // Close menu when clicking on overlay
      document.body.addEventListener('click', (event) => {
        if (event.target.classList.contains('page-overlay')) {
          this.closeHamburger();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hamburgerWrapper.classList.contains('active')) {
          this.closeHamburger();
        }
      });

      theme.onMobileSizeChange((isMobile) => {
        if (isMobile) {
          // if ( document.body.classList.contains('has-header-overlay')) {
          this.hamburgerWrapper.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
          // }
        }
      });
    }

    openHamburger() {
      if (!this.hamburgerWrapper) return;
      document.querySelectorAll('mega-menu').forEach(menu => {
        menu.closeAllMenus();
      });
      this.hamburgerWrapper.classList.add('active');
      document.body.classList.add('overflow-hidden');

      setTimeout(() => {
        trapFocus(this.hamburgerWrapper, this.hamburgerCloseBtn);
      }, 500);
    }

    closeHamburger() {
      if (!this.hamburgerWrapper) return;

      const { dataset } = this.hamburgerWrapper;

      // if (dataset.openMenu === 'click') {
      this.hamburgerWrapper
        .querySelectorAll('[nav-links], [nav-child-links]')
        .forEach((link) => link.classList.remove('open'));
      // }

      this.hamburgerWrapper.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

      setTimeout(() => {
        this.querySelector('button')?.focus();
      }, 500);
      // document.body.classList.remove('has-header-overlay');
    }
  }
  customElements.define('header-hamburger-btn', HeaderButton);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-products-display"] && !Shopify.designMode) return;
  try {
    
  class OfferCopyToClipboard extends HTMLButtonElement {
    constructor() {
      super();
      this.copyId = this.dataset.id; // Get the `data-id` attribute value
      this.copiedText = this.dataset.copied || 'Copied!'; // Text to show when copied
      this.init();
    }

    init() {
      this.addEventListener('click', this.handleCopy.bind(this));
    }

    async handleCopy() {
      if (!this.copyId) {
        console.error('No data-id found to copy!');
        return;
      }

      try {
        // Attempt to use the Clipboard API
        await navigator.clipboard.writeText(this.copyId);
        this.showCopiedMessage();
      } catch (error) {
        // Fallback to execCommand if Clipboard API fails
        console.warn('Clipboard API failed, falling back to execCommand:', error);
        this.fallbackCopy();
      }
    }

    fallbackCopy() {
      const tempInput = document.createElement('input');
      tempInput.value = this.copyId;
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px';
      document.body.appendChild(tempInput);

      tempInput.select();
      document.execCommand('copy'); // Deprecated but used as a fallback
      document.body.removeChild(tempInput);

      this.showCopiedMessage();
    }

    showCopiedMessage() {
      const copiedMessage = document.createElement('div');
      copiedMessage.textContent = this.copiedText;
      copiedMessage.className = 'offer-copied-message';
      copiedMessage.style.opacity = '0';

      this.closest('[data-clipboard-wrapper]')?.appendChild(copiedMessage);

      setTimeout(() => {
        copiedMessage.style.opacity = '1';
      }, 0);

      setTimeout(() => {
        copiedMessage.style.opacity = '0';
        copiedMessage.remove();
      }, 2000);
    }
  }
  customElements.define('offer-copy-to-clipboard', OfferCopyToClipboard, { extends: 'button' });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initVideoProductReel(container) {
      if (!container) return;

      if (container.dataset.reelInitialized === 'true') {
        return;
      }

      container.dataset.reelInitialized = 'true';

      var viewport = container.querySelector('[data-reel-viewport]');

      var slides = Array.from(container.querySelectorAll('[data-reel-slide]'));

      var prevButton = container.querySelector('[data-reel-prev]');

      var nextButton = container.querySelector('[data-reel-next]');

      var dots = Array.from(container.querySelectorAll('[data-reel-dot]'));

      if (!viewport || !slides.length) {
        return;
      }

      var autoplay = container.dataset.autoplay === 'true';

      var autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 4000;

      var pauseOnHover = container.dataset.pauseHover === 'true';

      var autoplayTimer = null;

      var currentIndex = 0;

      var userInteracting = false;

      /* ======================================================
       GET CURRENT SLIDE
       ====================================================== */

      function getCurrentIndex() {
        var viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;

        var closestIndex = 0;

        var closestDistance = Infinity;

        slides.forEach(function (slide, index) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;

          var distance = Math.abs(viewportCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;

            closestIndex = index;
          }
        });

        return closestIndex;
      }

      /* ======================================================
       UPDATE DOTS
       ====================================================== */

      function updateDots() {
        currentIndex = getCurrentIndex();

        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === currentIndex);
        });
      }

      /* ======================================================
       SCROLL TO SLIDE
       ====================================================== */

      function goToSlide(index) {
        if (!slides.length) return;

        if (index >= slides.length) {
          index = 0;
        }

        if (index < 0) {
          index = slides.length - 1;
        }

        var slide = slides[index];

        var left = slide.offsetLeft;

        viewport.scrollTo({
          left: left,
          behavior: 'smooth',
        });

        currentIndex = index;

        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      /* ======================================================
       NEXT
       ====================================================== */

      function nextSlide() {
        currentIndex = getCurrentIndex();

        goToSlide(currentIndex + 1);
      }

      /* ======================================================
       PREVIOUS
       ====================================================== */

      function previousSlide() {
        currentIndex = getCurrentIndex();

        goToSlide(currentIndex - 1);
      }

      /* ======================================================
       AUTOPLAY
       ====================================================== */

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);

          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();

        if (!autoplay) return;

        if (slides.length <= 1) return;

        if (userInteracting) return;

        autoplayTimer = setInterval(function () {
          nextSlide();
        }, autoplaySpeed);
      }

      function restartAutoplay() {
        stopAutoplay();

        startAutoplay();
      }

      /* ======================================================
       ARROWS
       ====================================================== */

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          nextSlide();

          restartAutoplay();
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          previousSlide();

          restartAutoplay();
        });
      }

      /* ======================================================
       DOTS
       ====================================================== */

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.dataset.reelDot, 10);

          goToSlide(index);

          restartAutoplay();
        });
      });

      /* ======================================================
       SCROLL / SWIPE
       ====================================================== */

      var scrollTimer;

      viewport.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollTimer);

          scrollTimer = setTimeout(function () {
            updateDots();
          }, 100);
        },
        {
          passive: true,
        }
      );

      viewport.addEventListener(
        'touchstart',
        function () {
          userInteracting = true;

          stopAutoplay();
        },
        {
          passive: true,
        }
      );

      viewport.addEventListener(
        'touchend',
        function () {
          userInteracting = false;

          setTimeout(function () {
            updateDots();

            startAutoplay();
          }, 1000);
        },
        {
          passive: true,
        }
      );

      /* ======================================================
       PAUSE ON HOVER
       ====================================================== */

      if (pauseOnHover) {
        container.addEventListener('mouseenter', function () {
          userInteracting = true;

          stopAutoplay();
        });

        container.addEventListener('mouseleave', function () {
          userInteracting = false;

          startAutoplay();
        });
      }

      /* ======================================================
       VIDEO MODAL
       ====================================================== */

      var modal = container.querySelector('[data-video-modal]');

      var player = container.querySelector('[data-video-player]');

      var openButtons = container.querySelectorAll('[data-video-open]');

      var closeButtons = container.querySelectorAll('[data-video-close]');

      function openVideo(button) {
        if (!modal || !player) return;

        var sourceVideo = button.querySelector('video');

        if (!sourceVideo) return;

        stopAutoplay();

        player.innerHTML = '';

        var clonedVideo = sourceVideo.cloneNode(true);

        clonedVideo.removeAttribute('autoplay');

        clonedVideo.removeAttribute('muted');

        clonedVideo.muted = false;

        clonedVideo.controls = true;

        clonedVideo.loop = false;

        clonedVideo.playsInline = true;

        player.appendChild(clonedVideo);

        modal.classList.add('is-open');

        modal.setAttribute('aria-hidden', 'false');

        document.body.style.overflow = 'hidden';

        var playPromise = clonedVideo.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            clonedVideo.muted = true;

            clonedVideo.play().catch(function () {});
          });
        }
      }

      function closeVideo() {
        if (!modal || !player) return;

        var video = player.querySelector('video');

        if (video) {
          video.pause();
        }

        player.innerHTML = '';

        modal.classList.remove('is-open');

        modal.setAttribute('aria-hidden', 'true');

        document.body.style.overflow = '';

        userInteracting = false;

        startAutoplay();
      }

      openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          openVideo(button);
        });
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeVideo);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
          closeVideo();
        }
      });

      /* ======================================================
       PAUSE VIDEOS WHEN OFF SCREEN
       ====================================================== */

      var videos = container.querySelectorAll('.video-product-reel__video');

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;

              if (entry.isIntersecting) {
                var promise = video.play();

                if (promise && typeof promise.catch === 'function') {
                  promise.catch(function () {});
                }
              } else {
                video.pause();
              }
            });
          },

          {
            threshold: 0.15,
          }
        );

        videos.forEach(function (video) {
          observer.observe(video);
        });

        container.__videoProductObserver = observer;
      }

      /* ======================================================
       INITIALIZE
       ====================================================== */

      updateDots();

      startAutoplay();
    }

    /* ========================================================
     INIT ALL
     ======================================================== */

    function initAll(root) {
      var scope = root || document;

      if (scope.matches && scope.matches('.video-product-reel')) {
        initVideoProductReel(scope);
      }

      scope.querySelectorAll('.video-product-reel').forEach(initVideoProductReel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    /* Shopify Theme Editor */

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var reel = event.target.querySelector('.video-product-reel');

      if (reel && reel.__videoProductObserver) {
        reel.__videoProductObserver.disconnect();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
